// src/components/Customer/CustomerTable.jsx
import React from 'react';
import RoleBasedComponent from '../common/RoleBasedComponent';
const CustomerTable = ({ customers, onEdit, onDelete, isLoading }) => {
  if (isLoading) {
    return (
      <div className="data-table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th><th>Name</th><th>Shop</th><th>Town</th><th>Contact</th>
              <th>Route</th><th>Credit Limit</th><th>Active</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colSpan="9" style={{textAlign:'center'}}>Loading customers...</td></tr>
          </tbody>
        </table>
      </div>
    );
  }

  if (!customers?.length) {
    return (
      <div className="data-table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th><th>Name</th><th>Shop</th><th>Town</th><th>Contact</th>
              <th>Route</th><th>Credit Limit</th><th>Active</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colSpan="9" style={{textAlign:'center'}}>No customers match the current filter.</td></tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th><th>Name</th><th>Shop</th><th>Town</th><th>Contact</th>
            <th>Route</th><th>Credit Limit</th><th>Active</th><th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr key={customer.id || customer.customerId}>
              <td>{customer.id || customer.customerId}</td>
              <td>{customer.name}</td>
              <td>{customer.shopName}</td>
              <td>{customer.town}</td>
              <td>{customer.contactNumber}</td>
              <td>{customer.route?.name || customer.routeName || customer.routeId}</td>
              <td>Rs. {customer.creditLimit?.toLocaleString()}</td>
              <td>
                <span className={`category-status-badge ${
                  customer.isActive ? 'category-status-active' : 'category-status-inactive'
                }`}>
                  {customer.isActive ? (
                    <>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: '4px' }}>
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                      </svg>
                      Active
                    </>
                  ) : (
                    <>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: '4px' }}>
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                      </svg>
                      Inactive
                    </>
                  )}
                </span>
              </td>
              <td>
                <button 
  className="btn btn-action btn-edit" 
  onClick={() => onEdit(customer)}
  title="Edit this customer"
>
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
  Edit
</button>

<RoleBasedComponent allowedRoles={['superadmin']}>
  <button 
    className="btn btn-action btn-delete" 
    onClick={() => onDelete(customer)} 
    title="Delete this customer"
    style={{ marginLeft: '8px' }}
  >
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
    Delete
  </button>
</RoleBasedComponent>
                
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomerTable;
